import styled from '@emotion/styled';

export const Container = styled.div`
  .grecaptcha-badge {
    visibility: hidden !important;
  }
`;

export const Disclaimer = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
`;

export const PageWrapper = styled.div`
  height: 100dvh;
  width: 100dvw;
`;
